import * as types from '../action-types';
import { ActionSidebarReducerType } from '../decisionState.types';
import { ActionSidebarActions } from '../actions';

const initialState: ActionSidebarReducerType = {
  isOpen: false,
  isRemove: false,
  top: -9999,
  left: 0,
};

export function actionSidebarReducer(
  state: ActionSidebarReducerType = initialState,
  action: ActionSidebarActions,
) {
  switch (action.type) {
    case types.openActionSidebarPopover: {
      const { data } = action.payload;
      return { ...state, isOpen: true, ...data };
    }
    case types.closeActionSidebarPopover: {
      return {
        ...state,
        isOpen: false,
        isRemove: false,
        top: -9999,
      };
    }
    case types.switchActionSidebarRemove: {
      return {
        ...state,
        isRemove: true,
      };
    }
    default: {
      return state;
    }
  }
}
